export default __webpack_public_path__ + "static/media/couple.4a096d82.png";